

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ProductWiseSalesParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface ProductWiseSales {

  fromDate: any;
  toDate: string;
  medicineType: string;
  physicianId: any;
   
  skip:Number,
  take:Number,
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: ProductWiseSalesParameter[];
    links?: any;
}

export abstract class ProductWiseSalesData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<ProductWiseSales[]>;
  abstract searchList(url: string,data: any): Observable<any>;
  abstract update(url: string,data: ProductWiseSales): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
